export default function(state = {}, action) {
	switch (action.type) {
		case 'LOADED_MODULE_BUILDER_IMAGES':
			return state.set('loaded', true)
		//default just return state
		default:
			return state
	}
}
